/* Component Dependencies */
var connectWithUsTemplate = require('templates/connectWithUs.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
	type: 'connectWithUs',

	template: {
		'connectWithUs': connectWithUsTemplate
	},
  subscribe: {
    'TOGGLE_CONNECT_US': 'toggleConnectUs'
  },
	bindEvents: function() {
		var _self = this,facebookLocale='';
		_self.locale = _self.$el.find('.l-share-button-container').data('locale');
		_self.facebookUrl = _self.$el.find('.js-fb-like').data('url');
		_self.facebookUrlSuffix = _self.$el.find('.js-fb-like').data('url-suffix');
		_self.facebookId = _self.$el.find('.js-fb-like').data('id');
		_self.googleUrl = _self.$el.find('.js-gplus-share').data('url');
		_self.twitterUrl = _self.$el.find('.js-twitter-tweet').data('url');
		_self.twitterId = _self.$el.find('.js-twitter-tweet').data('id');
		facebookLocale=_self.locale=='ar_AE'?'ar_AR':_self.locale;
		window.___gcfg = {lang: _self.locale};
		this.initSocialShareButton(_self.facebookUrl + facebookLocale + _self.facebookUrlSuffix, _self.facebookId);
		this.initSocialShareButton(_self.googleUrl);
		this.initSocialShareButton(_self.twitterUrl, _self.twitterId);
	},

	/**
	 * This function inits the social share button based on arguments passed
	 * @param {src} script source url
	 * @param {id} script tag id
	 * @returns {Boolean} Initialization done successfully or not
	 */
	initSocialShareButton: function _initSocialShareButton(src, id) {
		var newNode = document.createElement('script'),
			scriptNode = document.getElementsByTagName('script')[0];

		if (src === undefined) {
			return false;
		}

		if (id !== undefined && document.getElementById(id)) {
			return false;
		}

		if (id !== undefined) {
			newNode.id = id;
		}

		newNode.src = src;
		newNode.type = "text/javascript";
		newNode.async = true;

		scriptNode.parentNode.insertBefore(newNode, scriptNode);
		return true;
	},
  toggleConnectUs: function _toggleConnectUs(isTileDisplayed){
    var _self=this;
    isTileDisplayed===true?_self.$el.removeClass('l-display-none').addClass('l-display-block'):_self.$el.removeClass('l-display-block').addClass('l-display-none');
  }
});
